var XPortal = XPortal || {};
XPortal.Chart = (function () {
    var drawing = kendo.drawing;
    var geometry = kendo.geometry;
    const isDarkTheme = document.body.classList.contains('theme-dark');
    const textColor = isDarkTheme ? '#A2A6BB' : '#344054';
    const gridColor = isDarkTheme ? '#474C69' : '#C8D2E2';
    var XpandChartTheme = {
        chart: {
            title: { color: textColor },
            tooltip: {
                visible: true,
                background: "#344054",
                color: "#FFF",
                font: "12px Rubik",
                padding: { top: 3, bottom: 3, left: 8, right: 8 },
                border: {
                    width: 0,
                },
            },
            legend: {
                align: "start",
                margin: {
                    top: 20
                },
                labels: {
                    color: textColor,
                    font: '12px Rubik',

                },
                inactiveItems: {
                    labels: { color: '#919191' },
                    markers: { color: '#919191' }
                },
                item: {
                    markers: {
                        // draw legend marker as Circle
                        visual: function (e) {
                            var rect = e.rect;
                            var center = rect.center();
                            var circle = new drawing.Circle(new kendo.geometry.Circle([center.x, center.y], rect.size.width / 2), {
                                fill: {
                                    color: e.options.border.color,
                                },
                                stroke: {
                                    color: e.options.border.color,
                                    width: 1
                                }
                            });

                            return circle;
                        }
                    },
                }
            },
            seriesDefaults: {
                type: "line",
                style: "smooth",
                labels: {
                    color: '#fff'
                },
                errorBars: { color: '#fff' },
                notes: {
                    icon: {
                        background: '#3b3b3b',
                        border: { color: '#8e8e8e' }
                    },
                    label: { color: '#fff' },
                    line: { color: '#8e8e8e' }
                },
                pie: { overlay: { gradient: 'sharpBevel' } },
                donut: { overlay: { gradient: 'sharpGlass' } },
                line: { markers: { background: '#3d3d3d' } },
                scatter: { markers: { background: '#3d3d3d' } },
                scatterLine: { markers: { background: '#3d3d3d' } },
                waterfall: { line: { color: '#8e8e8e' } },
                horizontalWaterfall: { line: { color: '#8e8e8e' } },
                candlestick: {
                    downColor: '#555',
                    line: { color: '#fff' },
                    border: {
                        _brightness: 1.5,
                        opacity: 1
                    },
                    highlight: {
                        border: {
                            color: '#fff',
                            opacity: 0.2
                        }
                    }
                },
                ohlc: { line: { color: '#fff' } },
            },
            chartArea: { background: '' },
            seriesColors: [
                '#43C1E9',
                '#3aafff',
                '#99c900',
                '#ffeb3d',
                '#b20753',
                '#ff4195'
            ],
            axisDefaults: {
                line: {
                    color: gridColor,
                    dashType: 'dash',
                },
                labels: {
                    color: textColor,
                },
                majorGridLines: {
                    color: gridColor,
                    dashType: 'dash',
                },
                minorGridLines: {
                    color: gridColor,
                    dashType: 'dash',
                },
                title: { color: '#fff' },
                crosshair: { color: '#8e8e8e' },
                // notes: {
                //     icon: {
                //         background: '#3b3b3b',
                //         border: { color: '#8e8e8e' }
                //     },
                //     label: { color: '#fff' },
                //     line: { color: '#8e8e8e' }
                // }
            }
        },
        gauge: {
            pointer: { color: '#0070e4' },
            scale: {
                rangePlaceholderColor: '#1d1d1d',
                labels: { color: '#fff' },
                minorTicks: { color: '#fff' },
                majorTicks: { color: '#fff' },
                line: { color: '#fff' }
            }
        },
        diagram: {
            shapeDefaults: {
                fill: { color: '#0066cc' },
                connectorDefaults: {
                    fill: { color: '#fff' },
                    stroke: { color: '#384049' },
                    hover: {
                        fill: { color: '#3d3d3d' },
                        stroke: { color: '#efefef' }
                    }
                },
                content: { color: '#fff' }
            },
            editable: {
                resize: {
                    handles: {
                        fill: { color: '#3d3d3d' },
                        stroke: { color: '#fff' },
                        hover: {
                            fill: { color: '#fff' },
                            stroke: { color: '#fff' }
                        }
                    }
                },
                rotate: {
                    thumb: {
                        stroke: { color: '#fff' },
                        fill: { color: '#fff' }
                    }
                }
            },
            selectable: { stroke: { color: '#fff' } },
            connectionDefaults: {
                stroke: { color: '#fff' },
                content: { color: '#fff' },
                selection: {
                    handles: {
                        fill: { color: '#3d3d3d' },
                        stroke: { color: '#efefef' }
                    }
                }
            }
        },
        treeMap: {
            colors: [
                [
                    '#0081da',
                    '#314b5c'
                ],
                [
                    '#3aafff',
                    '#3c5464'
                ],
                [
                    '#99c900',
                    '#4f5931'
                ],
                [
                    '#ffeb3d',
                    '#64603d'
                ],
                [
                    '#b20753',
                    '#543241'
                ],
                [
                    '#ff4195',
                    '#643e4f'
                ]
            ]
        }
    };

    function isMobileViewport() {
        if (XPortal.Utils && typeof XPortal.Utils.getViewportName === "function") {
            var vp = XPortal.Utils.getViewportName();
            return vp === "xs" || vp === "sm";
        }
        if (XPortal.Utils && typeof XPortal.Utils.getViewportWidth === "function") {
            return XPortal.Utils.getViewportWidth() < 768;
        }
        return window.innerWidth < 768;
    }

    function isCompact(width, minWidth) {
        return isMobileViewport() || width < minWidth;
    }

    var self = {
        drawing: null,
        geometry: null,
        timeoutId: false,
        XpandChartTheme: XpandChartTheme,
        isCompact: isCompact,
        applyTopology: applyTopology,
        shadeColor: shadeColor,
        isLast: isLast,
        filterOutInvisible: filterOutInvisible,
        Init: function (chartselector, seriesArray, categoriesArray, chartTheme, disableResizing) {
            kendo.dataviz.ui.registerTheme("XpandChartTheme", XpandChartTheme);
            //bar, line, pie, donut, column, 3dcolumn, area, 3dbar (+stacked)
            XPortal.Chart.drawing = drawing;
            XPortal.Chart.geometry = kendo.geometry;
            if (arguments.length < 1) return null;
            var chartEl = $(chartselector);
            var sttgs = XPortal.Chart.initSeriesAndCategories(
                chartEl,
                {
                    series: seriesArray,
                    categories: categoriesArray,
                    chartTheme,
                    disableResizing: disableResizing ? true : false,
                }
            );
            return sttgs ? ensureInit(chartEl, sttgs) : null;
        },
        InitEmpty: function createEmptyChart(chartEl, typeChart) {
            var chartTheme = chartEl.attr("data-themename");
            if (!chartTheme || chartTheme == 'default') {
                chartTheme = "XpandChartTheme";
            }
            chartEl.kendoChart({
                theme: chartTheme,
                categoryAxis: {
                    categories: [1, 2, 3, 4, 5, 6], justified: false
                },
                seriesDefaults: {
                    type: typeChart === "ring" ? "donut" : typeChart,
                },
                render: function (e) {
                    e.sender.element.prev().addClass('show');
                },
            });
            XPortal.Chart.DisplayLoading(chartEl.closest('.chart-wrapper'));
        },
        DisplayLoading: function displayLoading(element) {
            XPortal.Loader.show({ selector: element, autoHideTime: 3000 });
        },
        ResizeChart: function (chartEl) {
            var $el = $(chartEl);
            var kchart = $el.data("kendoChart");
            if (kchart && kchart.options && kchart.options.arrange && kchart.options.arrange(kchart.options, $el.width())) {
                kchart.redraw();
            }
            kendo.resize($el);
        },
        initSeriesAndCategories: function (el, optionsExtra) {
            var res = XPortal.Utils.readJsonStr(el.attr("data-chart-settings"), null);//el.attr("data-themename")
            if (!res) return;
            for (var i in optionsExtra)
                if (optionsExtra[i]) res[i] = optionsExtra[i];
            res.series = res.series || [];
            res.categories = res.categories || [];
            res = ensureCategoryFormatForWeek(res);
            res.hasCustomTooltip = !!res.tooltip;
            res.tooltip = res.tooltip || "#= dataItem.startdate # to #= dataItem.enddate # : #= value #";
            res.txColor = res.label.txcolor;
            res.bgColor = res.label.bgcolor;
            res.chartType = el.attr("typeof") || res.chartType;
            res.stacked = res.chartType && res.chartType.indexOf('stacked') > -1;
            if (res.stacked) res.chartType = res.chartType.replace('stacked', '');
            res.reverse = el.attr("reverse");
            res.label.position = isOneOf(res.chartType, "pie", "donut", "ring") ? "insideEnd" : res.label.position || "outsideEnd";
            res.label.template = res.label.template || "#= value #";
            res.label.legendPosition = res.label.legendPosition || "bottom";
            res.hAxisAngle = isNaN(Number(res.label.hAxisAngle)) ? res.label.hAxisAngle : parseInt(res.label.hAxisAngle);
            res.vAxisAngle = isNaN(Number(res.label.vAxisAngle)) ? res.label.vAxisAngle : parseInt(res.label.vAxisAngle);
            try {
                res.series.forEach(function (s) {
                    const template = kendo.template(s.legendtemplate);
                    s.name = template({ value: s.legendvalue });
                });
                applyTopology(res.series);
                if (isOneOf(res.chartType, "ring")) XPortal.ChartRing.CombineSeries(res);
            } catch (e) { if (console) console.log(e, res, optionsExtra); }
            return res;
        },
        DataLoaded: function (id) {
            var chartId = '#chart-' + id;
            self.InitDateEditors(chartId);
            $(chartId).find('.navportal-chart').each(function () {
                XPortal.Chart.Init($(this));
            });
            if ($(chartId).length > 0)
                XPortal.Dashboard.PrepareSearchRequest($(chartId).attr("id"));
        },
        InitDateEditors: function (chartId) {
            var dt = $(chartId).find(".chard-date-editor").each(function (ip, element) {
                var el = jQuery(element);
                var elHddn = el.find("input");
                var dateVal = elHddn.val();
                var dateFormat = el.attr("data-format");
                dateFormat = dateFormat.replace(/D/g, "d");
                var inputWidth = dateVal.length * 10 + 65;
                el.css("width", inputWidth + "px");
                var sttgs =
                {
                    value: kendo.toString(dateVal, dateFormat),
                    dateInput: false,
                    depth: "month",
                    start: "month",
                    change: function () {
                        self.DateHasBeenChanged(el);
                    },
                    close: function () {
                        self.DateHasBeenChanged(el);
                    },
                    format: dateFormat,
                    parseFormats: [dateFormat]
                };
                elHddn.kendoDatePicker(sttgs);
                el.on("click", function () {
                    clearTimeout(self.xinterval);
                    elHddn.data("kendoDatePicker").open();
                });
            });

            $(chartId).find(".chard-date-editor-disabled").each(function (ip, element) {
                var el = jQuery(element);
                var elHddn = el.find("input");
                var dateVal = elHddn.val();
                var inputWidth = dateVal.length * 10 + 65;
                el.css("width", inputWidth + "px");
            });

            $(chartId).find(".chard-rotate").each(function (ip, element) {

            });
        },
        DateHasBeenChanged: function (el) {
            self.xinterval = self.xinterval ? self.xinterval : 0;
            clearTimeout(self.xinterval);
            var frm = el.closest(".dashboard-async-item");
            if (frm.length > 0)
                self.xinterval = setTimeout(function () {
                    frm.submit();
                    XPortal.Loader.show({ selector: frm });
                }, 2000);
        },
        createColumn: function (rect, color, chartType) {
            var origin = rect.origin;
            var center = rect.center();
            var bottomRight = rect.bottomRight();
            var radiusX = rect.width() / 2;
            var radiusY = radiusX / 5;
            var isHoriz = chartType == "3dcolumnh";
            var gradient = !isHoriz
                ? new drawing.LinearGradient({ stops: [{ offset: 0, color: color }, { offset: 0.5, color: color, opacity: 0.9 }, { offset: 0.5, color: color, opacity: 0.9 }, { offset: 1, color: color }] })
                : new drawing.LinearGradient({ stops: [{ offset: 0, color: color }, { offset: 0.5, color: color, opacity: 0.9 }, { offset: 0.5, color: color, opacity: 0.9 }, { offset: 1, color: color }] });
            var path = !isHoriz
                ? new drawing.Path({ fill: gradient, stroke: { color: "none" } }).moveTo(origin.x, origin.y).lineTo(origin.x, bottomRight.y).arc(180, 0, radiusX, radiusY, true).lineTo(bottomRight.x, origin.y).arc(0, 180, radiusX, radiusY)
                : new drawing.Path({ fill: gradient, stroke: { color: "none" } }).moveTo(origin.x, origin.y).lineTo(origin.x, bottomRight.y).arc(180, 0, radiusX, radiusY, true).lineTo(bottomRight.x, origin.y).arc(0, 180, radiusX, radiusY);

            var topArcGeometry = new geometry.Arc([center.x, origin.y], { startAngle: 0, endAngle: 360, radiusX: radiusX, radiusY: radiusY });
            var topArc = new drawing.Arc(topArcGeometry, { fill: { color: color }, stroke: { color: "#ebebeb" } });
            var group = new drawing.Group();
            group.append(path, topArc);
            return group;
        },
        createBarColumn: function (rect, color, chartType) {
            var origin = rect.origin;
            var center = rect.center();
            var bottomRight = rect.bottomRight();
            var isHoriz = chartType == "3dbarcolumnh";
            var radius = !isHoriz ? { x: rect.width() / 2, y: rect.width() / 10 } : { x: rect.height() / 12, y: rect.height() / 3 };
            var gArc = !isHoriz
                ? { top: new geometry.Arc([center.x, origin.y], { startAngle: 0, endAngle: 360, radiusX: radius.x, radiusY: radius.y }), btm: new geometry.Arc([center.x, bottomRight.y], { startAngle: 0, endAngle: 360, radiusX: radius.x, radiusY: radius.y }) }
                : { top: new geometry.Arc([bottomRight.x, center.y], { startAngle: 0, endAngle: 360, radiusX: radius.x, radiusY: radius.y }), btm: new geometry.Arc([origin.x, center.y], { startAngle: 0, endAngle: 360, radiusX: radius.x, radiusY: radius.y }) };
            var points = !isHoriz
                ? { top: gArc.top.pointAt(90), btm: gArc.btm.pointAt(90), trt: gArc.top.pointAt(270) }
                : { top: gArc.top.pointAt(0), btm: gArc.btm.pointAt(180), trt: gArc.top.pointAt(180) };

            var colorR = shadeColor(color, -35);
            var gradient = new drawing.LinearGradient({ stops: [{ offset: 0, color: color }, { offset: 0.5, color: color, opacity: 0.9 }, { offset: 0.5, color: color, opacity: 0.9 }, { offset: 1, color: color }] });
            var gradientR = new drawing.LinearGradient({ stops: [{ offset: 0, color: colorR }, { offset: 0.35, color: colorR, opacity: 0.9 }, { offset: 0.4, color: colorR, opacity: 0.9 }, { offset: 1, color: colorR }] });

            var pathLeft = !isHoriz
                ? new drawing.Path({ fill: gradient, stroke: { color: "none" } }).moveTo(origin.x, origin.y).lineTo(origin.x, bottomRight.y).lineTo(points.btm.x, points.btm.y).lineTo(points.top.x, points.top.y).lineTo(origin.x, origin.y)
                : new drawing.Path({ fill: gradient, stroke: { color: "none" } }).moveTo(origin.x, origin.y).lineTo(bottomRight.x, origin.y).lineTo(points.top.x, points.top.y).lineTo(points.btm.x, points.btm.y).lineTo(origin.x, origin.y);
            var pathRight = !isHoriz
                ? new drawing.Path({ fill: gradientR, stroke: { color: "none" } }).moveTo(points.top.x, points.top.y).lineTo(bottomRight.x, origin.y).lineTo(bottomRight.x, bottomRight.y).lineTo(points.btm.x, points.btm.y).lineTo(points.top.x, points.top.y)
                : new drawing.Path({ fill: gradientR, stroke: { color: "none" } }).moveTo(points.top.x, points.top.y).lineTo(bottomRight.x, bottomRight.y).lineTo(origin.x, bottomRight.y).lineTo(points.btm.x, points.btm.y).lineTo(points.top.x, points.top.y);
            var topRomb = !isHoriz
                ? new drawing.Path({ fill: gradientR, stroke: { color: "none" } }).moveTo(origin.x, origin.y).lineTo(points.top.x, points.top.y).lineTo(bottomRight.x, origin.y).lineTo(points.trt.x, points.trt.y).lineTo(origin.x, origin.y)
                : new drawing.Path({ fill: gradientR, stroke: { color: "none" } }).moveTo(bottomRight.x, origin.y).lineTo(points.top.x, points.top.y).lineTo(bottomRight.x, bottomRight.y).lineTo(points.trt.x, points.trt.y).lineTo(bottomRight.x, origin.y);

            var group = new drawing.Group();
            group.append(pathLeft, pathRight, topRomb);
            return group;
        },
        createLegendItem: function (e, chartType) {
            var color = (e.series || {}).color ? e.series.color : e.options.markers.background;
            var labelColor = e.options.labels.color;
            var rect = new geometry.Rect([0, 0], [120, 50]);
            var layout = new drawing.Layout(rect, { spacing: 5, alignItems: "center" });
            var overlay = drawing.Path.fromRect(rect, { fill: { color: "#fff", opacity: 0 }, stroke: { color: "none" }, cursor: "pointer" });
            var column = null;
            if (chartType.indexOf("3dbarcolumn") >= 0) column = self.createBarColumn(new geometry.Rect([0, 0], [15, 10]), color, chartType);
            if (chartType.indexOf("3dcolumn") >= 0) column = self.createColumn(new geometry.Rect([0, 0], [15, 10]), color, chartType);
            else return e.createVisual();
            var label = new drawing.Text(e.series.name, [0, 0], { fill: { color: labelColor } });
            layout.append(column, label);
            layout.reflow();

            var group = new drawing.Group().append(layout, overlay);
            return group;
        },
        createRoundedBar: function (rect, color, cornerRadius, label = null, labelColor) {
            var width = rect.size.width;
            if (width == 0) return;
            if (width < 2 * cornerRadius) cornerRadius = width / 2;
            var origin = rect.origin;
            var bottomRight = rect.bottomRight();

            // Gradient definition
            var gradient = new drawing.LinearGradient({
                stops: [
                    { offset: 0, color: color },
                    { offset: 1, color: shadeColor(color, -10) }
                ]
            });

            // Create the column path
            var path = new drawing.Path({
                fill: gradient,
                stroke: { color: "none" }
            });

            // Start from the bottom-left
            path.moveTo(origin.x, bottomRight.y) // Bottom-left corner
                .lineTo(origin.x, origin.y) // Left vertical line (straight)
                .lineTo(bottomRight.x - cornerRadius, origin.y) // Top horizontal (straight to right corner)
                .curveTo( // Top-right corner
                    [bottomRight.x, origin.y],
                    [bottomRight.x, origin.y + cornerRadius],
                    [bottomRight.x, origin.y + cornerRadius]
                )
                .lineTo(bottomRight.x, bottomRight.y - cornerRadius) // Right vertical (to bottom corner)
                .curveTo( // Bottom-right corner
                    [bottomRight.x, bottomRight.y],
                    [bottomRight.x - cornerRadius, bottomRight.y],
                    [bottomRight.x - cornerRadius, bottomRight.y]
                )
                .lineTo(origin.x, bottomRight.y); // Bottom horizontal (straight to start)

            path.close();

            var rectBackground = new geometry.Rect([bottomRight.x + 5, origin.y + 3], [10, rect.size.height]);
            var layout = new drawing.Layout(rectBackground, { alignItems: 'center', justifyContent: 'center' });

            if (label) {
                var text = new drawing.Text(label, [0, 0], {
                    font: '14px Rubik',
                    fill: { color: labelColor },
                    align: 'center'
                });
                layout.append(text);
                layout.reflow();
            }

            var group = new drawing.Group().append(path, layout);
            return group;
        },
        createStackbar: function (rect, color) {
            var width = rect.size.width;
            if (width == 0) return;
            var origin = rect.origin;
            var bottomRight = rect.bottomRight();

            // Gradient definition
            var gradient = new drawing.LinearGradient({
                stops: [
                    { offset: 0, color: color },
                    { offset: 1, color: shadeColor(color, -10) }
                ]
            });

            // Create the column path
            var path = new drawing.Path({
                fill: gradient,
                stroke: { color: "none" }
            });

            // Start from the bottom-left
            path.moveTo(origin.x, bottomRight.y) // Bottom-left corner
                .lineTo(origin.x, origin.y) // Left vertical line (straight)
                .lineTo(bottomRight.x, origin.y) // Top horizontal (straight to right corner)
                .lineTo(bottomRight.x, bottomRight.y) // Right vertical (to bottom corner)
                .lineTo(origin.x, bottomRight.y); // Bottom horizontal (straight to start)

            path.close();
            return path;
        },
        createRoundedTopColumn: function (rect, color, cornerRadius, label, labelColor) {
            var height = rect.size.height;
            if (height == 0) return;
            if (height < 2 * cornerRadius) cornerRadius = height / 2;
            var origin = rect.origin;
            var bottomRight = rect.bottomRight();

            // Gradient definition
            var gradient = new drawing.LinearGradient({
                stops: [
                    { offset: 0, color: color },
                    { offset: 1, color: shadeColor(color, -10) }
                ]
            });

            // Create the column path
            var path = new drawing.Path({
                fill: gradient,
                stroke: { color: "none" }
            });

            // Start from the bottom-left
            path.moveTo(origin.x, bottomRight.y)
                .lineTo(origin.x, origin.y + cornerRadius) // Left vertical
                .curveTo( // Top-left corner
                    [origin.x, origin.y],
                    [origin.x + cornerRadius, origin.y],
                    [origin.x + cornerRadius, origin.y]
                )
                .lineTo(bottomRight.x - cornerRadius, origin.y) // Top horizontal
                .curveTo( // Top-right corner
                    [bottomRight.x, origin.y],
                    [bottomRight.x, origin.y + cornerRadius],
                    [bottomRight.x, origin.y + cornerRadius]
                )
                .lineTo(bottomRight.x, bottomRight.y) // Right vertical
                .lineTo(origin.x, bottomRight.y); // Bottom horizontal

            path.close();

            var rectBackground = new geometry.Rect([origin.x, origin.y - 20], [rect.size.width, 20]);
            var layout = new drawing.Layout(rectBackground, { alignItems: 'center', justifyContent: 'center' });

            if (label) {
                var text = new drawing.Text(label, [0, 0], {
                    font: '14px Rubik',
                    fill: { color: labelColor },
                    align: 'center'
                });
                layout.append(text);
                layout.reflow();
            }

            var group = new drawing.Group().append(path, layout);
            return group;
        },
        createStackColumn: function (rect, color, dataItem) {
            var height = rect.size.height;
            if (height == 0) return;
            var origin = rect.origin;
            var bottomRight = rect.bottomRight();

            // Gradient definition
            var gradient = new drawing.LinearGradient({
                stops: [
                    { offset: 0, color: color },
                    { offset: 1, color: shadeColor(color, -10) }
                ]
            });

            // Create the column path
            var path = new drawing.Path({
                fill: gradient,
                stroke: { color: "none" }
            });

            // Draw rectangle without rounded corners
            path.moveTo(origin.x, bottomRight.y)
                .lineTo(origin.x, origin.y) // Left vertical
                .lineTo(bottomRight.x, origin.y) // Top horizontal
                .lineTo(bottomRight.x, bottomRight.y) // Right vertical
                .lineTo(origin.x, bottomRight.y); // Bottom horizontal

            path.close();
            return path;
        },
    };
    let geom = kendo.geometry;
    let Group = drawing.Group;
    function ensureInit(chartEl, stgs) {
        var labelStyle = stgs.txColor ? { color: stgs.txColor || textColor } : { xzy: null };
        var labelColor = stgs.txColor || textColor;
        // var withNotes = isOneOf(stgs.chartType, "3dcolumn", "3dbarcolumn", "3dbarcolumnh", "bar", "column");
        var ownLabel = isOneOf(stgs.chartType, "3ddonut", "3dpie", "pie", "donut", "ring");
        var verticalChart = !stgs.stacked && isOneOf(stgs.chartType, "3dcolumn", "3dbarcolumn", "column");
        var chartType = stgs.chartType;

        var fnGetPoinColor = function (d) { if (d && d.dataItem) return d.dataItem.txtcolor || stgs.txColor; return stgs.txColor; };
        var fnGetPoinBgColor = function (d) { var xbgi = stgs.bgColor || "transparent"; if (d && d.dataItem) return d.dataItem.bgcolor || xbgi; return xbgi; };
        var valueAxisOpt = { visible: stgs.label.axisVisible.valueLines };
        var ctgryAxisOpt = { visible: stgs.label.axisVisible.categoryMajorLines };
        var axlabelStyle = $.extend({}, labelStyle, { visible: !stgs.label.axisVisible.hidden, rotation: "auto" });
        var chartOpts = {
            theme: 'XpandChartTheme',
            transitions: false,
            title: {
                text: chartEl.attr("data-chart-title")
            },
            legend: {
                visible: stgs.label.legendVisible,
                position: stgs.label.legendPosition,
                labels: labelStyle
            },
            labelVisible: stgs.label.visible,
            seriesDefaults: {
                type: stgs.chartType,
                stack: stgs.stacked,
                labels: {
                    visible: stgs.label.visible && !ownLabel,
                    position: 'center',
                    background: fnGetPoinBgColor,
                    color: labelColor,
                    animationDelay: 2500,
                    template: function (dataItem) {
                        if (!stgs.showemptyseries && dataItem.value === 0) {
                            return "";
                        }
                        return stgs.label.template.replace("#= value #", dataItem.value);
                    }
                },
                color: fnGetPoinColor,
                overlay: {
                    gradient: "none"
                },
                missingValues: 'zero'
            },
            series: markOntop(stgs.series, stgs.categories),
            chartArea: { background: "" },
            panes: [{ clip: false }],
            valueAxis: { labels: $.extend({}, axlabelStyle, { rotation: stgs.vAxisAngle }), majorGridLines: valueAxisOpt, line: valueAxisOpt },
            categoryAxis: { labels: $.extend({}, axlabelStyle, { rotation: stgs.hAxisAngle }), categories: stgs.categories, majorGridLines: ctgryAxisOpt, line: ctgryAxisOpt, reverse: stgs.reverse },
            tooltip: { visible: true, template: stgs.tooltip },
            seriesClick: function (e) {
                if (e.originalEvent.type === "contextmenu") e.originalEvent.preventDefault();
                else {
                    if (e.dataItem && e.dataItem.link) window.location = e.dataItem.link;
                }
            },
            render: function (e) {
                e.sender.element.prev().addClass('show');
                XPortal.Utils.getParentTabById(e.sender.element.attr('data-chart-id')).removeClass('strong-show');
            }
        };
        if (chartType.indexOf("3d") >= 0 && chartType.indexOf("column") >= 0) {
            chartOpts.legend.item = { visual: function (e) { return self.createLegendItem(e, chartType); } };
            chartOpts.seriesDefaults.type = chartType == "3dbarcolumnh" ? "bar" : "column";
            chartOpts.seriesDefaults.highlight = {
                toggle: function (e) {
                    e.preventDefault();
                    e.visual.opacity(e.show ? 0.8 : 1);
                }
            };
            chartOpts.seriesDefaults.visual = function (e) {
                var color = e.dataItem && e.dataItem.color ? e.dataItem.color : e.options.color;
                return chartType.indexOf("3dbarcolumn") >= 0 ? self.createBarColumn(e.rect, color, chartType) : self.createColumn(e.rect, color, chartType)
            };
        }

        if (chartType.indexOf("pie") >= 0 || chartType.indexOf("donut") >= 0) {
            init3DPieOrDonut(chartType, chartOpts, chartEl, stgs);
        }

        if (chartType.indexOf("ring") >= 0) {
            XPortal.ChartRing.Init(chartType, chartOpts, chartEl, stgs);
        }

        // Rounded borders for bar and column types
        if (chartType.indexOf("bar") >= 0 && chartType.indexOf("3d") < 0) {
            var isStack = chartOpts.seriesDefaults.stack;
            if (isStack) {
                chartOpts.seriesDefaults.visual = function (e) {
                    var rect = e.rect;
                    var color = e.options.color;
                    var cornerRadius = 4;
                    var label = null;
                    if (stgs.label.visible && !ownLabel) {
                        label = e.stackValue;
                    }
                    if (e.dataItem.topology.sorderNo == e.dataItem.topology.total || e.dataItem.ontop == true ) {
                        return self.createRoundedBar(rect, color, cornerRadius, label, labelColor);
                    } else {
                        return self.createStackbar(rect, color)
                    }
                };

            } else {
                chartOpts.seriesDefaults.visual = function (e) {
                    var rect = e.rect;
                    var color = e.options.color;
                    var cornerRadius = 4;
                    return self.createRoundedBar(rect, color, cornerRadius, null, labelColor);
                };
            }
        }

        if (chartType.indexOf("column") >= 0 && chartType.indexOf("3d") < 0) {
            var isStack = chartOpts.seriesDefaults.stack;

            if (isStack) {
                chartOpts.seriesDefaults.visual = function (e) {
                    var rect = e.rect;
                    var color = e.options.color;
                    var cornerRadius = 6;
                    var label = null;
                    if (stgs.label.visible && !ownLabel) {
                        label = e.stackValue;
                    }
                    if (e.dataItem.topology.sorderNo == e.dataItem.topology.total || e.dataItem.ontop == true ) {
                        return self.createRoundedTopColumn(rect, color, cornerRadius, label, labelColor);
                    } else {
                        return self.createStackColumn(rect, color, cornerRadius)
                    }
                };
            } else {
                chartOpts.seriesDefaults.visual = function (e) {
                    var rect = e.rect;
                    var color = e.options.color;
                    var cornerRadius = 6;

                    return self.createRoundedTopColumn(rect, color, cornerRadius, null, labelColor);
                };
            }
        }

        //  Rounded corners for Area type
        if (chartType.includes("area")) {
            chartOpts.series.forEach(item => item.line = { style: "smooth" });
        }

        XPortal.Utils.getParentTabById(chartEl.attr('data-chart-id')).addClass('strong-show');
        var xchart = chartEl.kendoChart(chartOpts);
        xchart.on("init", function (e) { });
        if (!stgs.disableResizing) {
            var resizeNamespace = "resize.chart_" + (chartEl.attr("id") || chartEl.attr("data-chart-id") || Math.random().toString(36).substring(2));
            $(window).off(resizeNamespace).on(resizeNamespace, function () {
                var timerId = chartEl.data("resizeTimerId");
                if (timerId) clearTimeout(timerId);
                chartEl.data("resizeTimerId", setTimeout(function () {
                    XPortal.Chart.ResizeChart(chartEl);
                }, 400));
            });
            XPortal.Chart.ResizeChart(chartEl);
        }
    }

    function markOntop(data, categories) {
        const allCategories = categories
        allCategories.forEach(category => {
            let hasValue = false;
            const candidates = [];
            data.forEach(series => {
                const item = series.data.find(d => d.category === category);
                if (item) {
                    const hasNonEmptyValue = item.value !== undefined && item.value !== null && item.value !== "" && item.value !== 0;
                    if (hasNonEmptyValue) {
                        hasValue = true;
                        candidates.push({ item, sorderNo: item.topology?.sorderNo ?? 0 });
                    }
                }
            });
            if (!hasValue) return;

            const allEmpty = data.every(series => {
                const item = series.data.find(d => d.category === category);
                return !item || item.value === "" || item.value === undefined || item.value === null || item.value === 0;
            });

            if (allEmpty) return;

            const max = candidates.reduce((maxItem, current) =>
                current.sorderNo > maxItem.sorderNo ? current : maxItem
            );

            max.item.ontop = true;
        });

        return data;
    };

    function applyTopology(series) {
        series.forEach((s, i) => {
            s.topology = { orderNo: i + 1, total: series.length };
            (s.data ?? []).forEach((sdi, sdii) => {
                sdi.topology = {
                    orderNo: sdii,
                    sorderNo: i + 1,
                    total: series.length,
                    zIndex: s.data.length - sdii,
                    isFirst: sdii === 0,
                    isLast: sdii + 1 === s.data.length
                };

                sdi.value ??= 0;
            });
        });
        return series;
    };

    function init3DPieOrDonut(chartType, chartOpts, chartEl, stgs) {
        adjustSeriesForPie(chartEl, chartOpts, stgs);
        chartOpts.instanceId = +new Date();
        chartOpts.transitions = false;//animation
        chartOpts.startAngle = 0;
        chartOpts.startAngleDx = 1;
        chartOpts.enableRotationSate = true;
        chartOpts.enableRotation = chartOpts.enableRotation == null ? !chartOpts.enableRotationSate : chartOpts.enableRotation;
        chartOpts.rotationSpeed = 100;
        chartOpts.seriesDefaults.type = chartType.indexOf("pie") >= 0 ? "pie" : "donut";
        chartOpts.seriesDefaults.missingValues = "gap";

        chartOpts.legend.position = "right";
        chartOpts.legend.item = { visual: function (e) { return self.createLegendItem(e, chartType); } };
        chartOpts.radiusX = Math.max(chartEl.height(), chartEl.width()) / Math.min(chartEl.height(), chartEl.width());
        chartOpts.radiusY = 1;
        chartOpts.startup = { distance: 0.00, height: 25, label: { template: "#= value #", render: chartOpts.labelVisible } };

        chartOpts.seriesDefaults.highlight = {
            distance: 0.1, opacityLevel: 0.25, tmout: -1,
            toggle: function (e) {
                if (!e.visual) return;
                e.preventDefault();
                if (!e.show) {
                    clearTimeout(chartOpts.seriesDefaults.highlight.tmout);
                    chartOpts.seriesDefaults.highlight.tmout = setTimeout(function () { chartOpts.enableRotation = true; }, 2500);
                } else {
                    chartOpts.enableRotation = false;
                    clearTimeout(chartOpts.seriesDefaults.highlight.tmout);
                }
                var opacity = e.show ? 0.99 : 1;
                e.visual.opacity(opacity);
                var visual = e.visual;
                var transform = null;
                if (e.show && e.dataItem.arc) {
                    var arc = e.dataItem.arc;
                    var center = arc.center;
                    var ncenter = moveCenterPoint(center, arc, chartOpts.seriesDefaults.highlight.distance);
                    transform = kendo.geometry.transform().translate(ncenter.x - center.x, ncenter.y - center.y);
                }
                //visual.transform(transform);
                for (var i = 0; i < visual.parent.parent.children.length; i++) {
                    var otherVI = visual.parent.parent.children[i];
                    if (e.dataItem != otherVI.chartElement.dataItem) {
                        otherVI.chartElement.visual.opacity(e.show ? chartOpts.seriesDefaults.highlight.opacityLevel : 1);
                    } else {
                        otherVI.chartElement.visual.opacity(e.show ? 1 : 1);
                    }
                }
            }
        };

        chartOpts.seriesDefaults.visual = function (e) {
            chartOpts.radiusX = Math.max(chartEl.height(), chartEl.width()) / Math.min(chartEl.height(), chartEl.width());
            chartOpts.radiusY = 1;
            var res = new Group();
            var tmpdata = chartEl.data("kendoChart").options.series[0];

            var opts = $.extend(true, {}, chartOpts, { btmSegment: { opacity: 0.5 }, topSegment: { opacity: 1 } });
            if (isLast(e) && chartType.indexOf("3d") == 0) {
                ensureDataItem(chartOpts, e/*, -chartOpts.startAngleDx*/);
                res.append(render3DPartPieOrDonut(new Group(), filterOutInvisible(e, tmpdata.data), chartOpts.startup.height, opts, e));
                res.append(create3dSegmentTop(e, opts));
            } else {
                ensureDataItem(chartOpts, e);
                res.append(create3dSegmentTop(e, opts));
            }
            return res;
        };
        var cInstanceId = chartOpts.instanceId;
        XPortal.Utils.waitFor(function () {
            if (cInstanceId != chartOpts.instanceId) return true;
            let mbox = chartEl.data("kendoChart");
            if (!mbox || !mbox.options.enableRotation) return;
            chartOpts.startAngle = chartOpts.startAngle + chartOpts.startAngleDx;
            if (chartOpts.startAngle > 360) chartOpts.startAngle = 0;
            mbox.redraw();
            return false;
        }, XPortal.Utils.waitFor, chartOpts.rotationSpeed);
    };
    function showPieOrDonutSerie(chartEl, index) {
        XPortal.Utils.waitFor(function () {
            let mbox = chartEl.data("kendoChart");
            if (!mbox) return false;
            kendo.unbind(chartEl);
            mbox.destroy();
            kendo.destroy(chartEl);
            chartEl.html("");
            var stgs = mbox.options.xstgs;
            stgs.xseriesCurrent = index;
            ensureInit(chartEl, stgs);
            return true;
        }, XPortal.Utils.waitFor, 1000);

    }
    function create3dSegmentTop(e, opts) {
        var rest = create3dSegmentsFrom(e.dataItem, opts, false, false, true, true);
        rest.options.zIndex = e.dataItem.topology.zIndex;
        rest.options.opacity = 0.7;
        return rest;
    }
    function ensureMaxAngle(ang) {
        ang = ang == null || ang < 0 ? 0 : ang;
        ang = ang >= 360 ? ang - 360 : ang;
        return ang;
    };
    function ensureDataItem(chartOpts, e, startAngDx) {
        var center = new geom.Point(e.center.x, e.center.y);
        e.innerRadius = e.innerRadius > 0 ? e.innerRadius : 0;
        startAngDx = startAngDx ? startAngDx : 0;
        var startAg = ensureMaxAngle(e.startAngle + chartOpts.startAngle + startAngDx);
        var endAngl = ensureMaxAngle(e.endAngle + chartOpts.startAngle + startAngDx);
        var arc = new geom.Arc(center, { 'startAngle': startAg, 'endAngle': endAngl, 'radiusX': chartOpts.radiusX * (e.radius + 0), 'radiusY': chartOpts.radiusY * (e.radius + 0) });
        e.dataItem.ncenter = chartOpts.startup.distance == 0 ? center : moveCenterPoint(center, arc, chartOpts.startup.distance);
        e.dataItem.arc = new geom.Arc(e.dataItem.ncenter, { 'startAngle': startAg, 'endAngle': endAngl, 'radiusX': chartOpts.radiusX * e.radius, 'radiusY': chartOpts.radiusY * e.radius });
        e.dataItem.innerArc = e.innerRadius > 0 ? new geom.Arc(e.dataItem.ncenter, { 'startAngle': startAg, 'endAngle': endAngl, 'radiusX': chartOpts.radiusX * e.innerRadius + 20, 'radiusY': chartOpts.radiusY * e.innerRadius }) : null;
        e.dataItem.color = e.dataItem && e.dataItem.color ? e.dataItem.color : e.options.color;
    }
    function render3DPartPieOrDonut(vcontainer, serieData, height, opts, e) {
        if (!serieData || serieData.find(function (xdi) { return xdi.arc == null; }) != null) return vcontainer;
        vcontainer.options.zIndex = e.dataItem.topology.zIndex;
        vcontainer.options.opacity = 0.6;
        serieData.forEach(function (xdi, xdii) {
            let res = create3dSegmentsFrom(xdi, opts, false, true, false, false, height);
            let rcrvo = res.children[0].children.find(function (ci) { return ci.topology.tname == "crvo"; });
            let rcrvi = res.children[0].children.find(function (ci) { return ci.topology.tname == "crvi"; });
            rcrvo.options.zIndex = 100;
            rcrvi.options.zIndex = 100;
            vcontainer.append(rcrvo);
            vcontainer.append(rcrvi);
        });
        return vcontainer;
    };
    function create3dSegmentsFrom(dataItem, opts, renderBtm, renderSide, renderTop, renderTxt, height) {
        height = height && height != null ? height : opts.startup.height;
        let center = dataItem.arc.center;
        let res = create3dSegments(dataItem.arc, center, height, dataItem.color, dataItem, dataItem.innerArc, opts, renderBtm, renderSide, renderTop, renderTxt);
        return res;
    };
    function create3dSegments(arc, center, height, color, txtTorender, innerArc, chartOpts, renderBtm, renderSide, renderTop, renderTxt) {
        var group = new Group();
        var center2 = new geom.Point(center.x, center.y + height);
        var arc2 = new geom.Arc(center2, arc);
        var tpg = txtTorender || { topology: {} };

        if (renderBtm) {
            var bottomSegment = createSegment(arc2, center2, shadeColor(color, 50), chartOpts.btmSegment.opacity, innerArc);
            bottomSegment.options.opacity = chartOpts.btmSegment.opacity;
            group.append(bottomSegment);
        }
        if (renderSide) {
            var sides = createSegmentSidebars(center, arc, center2, arc2, shadeColor(color, -20), chartOpts.btmSegment.opacity, innerArc);
            sides.options.opacity = chartOpts.topSegment.opacity;
            group.append(sides);
        }
        if (renderTop) {
            var opst = chartOpts.topSegment.opacity;
            var topSegment = createSegment(arc, center, color, opst, innerArc);
            topSegment.options.opacity = opst;
            group.append(topSegment);
        }
        if (renderTxt) {
            if (chartOpts.startup.label.render) {
                var txt = chartOpts.startup.label.template ? kendo.template(chartOpts.startup.label.template) : null;
                txt = txt ? txt(tpg) : tpg.value;
                var text = renderTextOnPie(arc, center, txt, topSegment, color, chartOpts);
                group.append(text);
            }
        }
        return group;
    }
    function createSegment(arc, center, clr, opct, innerArc) {
        var path2 = new drawing.Path({
            fill: { color: clr, opacity: opct }, stroke: { color: clr, opacity: opct }, zIndex: 2
        });

        var Oe = arc.pointAt(arc.endAngle);
        if (innerArc == null) {
            path2.moveTo(Oe.x, Oe.y);
            path2.arc(arc.endAngle, arc.startAngle, arc.radiusX, arc.radiusY, true);
            path2.lineTo(center.x, center.y).close();
        } else {
            innerArc.center = center;
            var Is = innerArc.pointAt(innerArc.startAngle);
            path2.moveTo(Oe.x, Oe.y);
            path2.arc(arc.endAngle, arc.startAngle, arc.radiusX, arc.radiusY, true);
            path2.lineTo(Is.x, Is.y);
            path2.arc(innerArc.startAngle, innerArc.endAngle, innerArc.radiusX, innerArc.radiusY, false);
            path2.lineTo(Oe.x, Oe.y);
            path2.close();
        }
        return path2;
    }
    function createSegmentSidebars(c1, arc1, c2, arc2, clr, opct, innerArc) {
        var gp = new Group();
        arc1.endAngle = ensureMaxAngle(arc1.endAngle);
        arc1.startAngle = ensureMaxAngle(arc1.startAngle);
        arc2.endAngle = ensureMaxAngle(arc2.endAngle);
        arc2.startAngle = ensureMaxAngle(arc2.startAngle);
        var cntA = (arc1.startAngle + arc1.endAngle) / 2;
        var path1 = new drawing.Path({ fill: { color: clr, opacity: opct }, stroke: { color: clr, opacity: opct } });
        var path2 = new drawing.Path({ fill: { color: clr, opacity: opct }, stroke: { color: clr, opacity: opct } });
        var path3 = new drawing.Path({ fill: { color: clr, opacity: opct }, stroke: { color: clr, opacity: opct } });
        var path4 = new drawing.Path({ fill: { color: clr, opacity: opct }, stroke: { color: clr, opacity: opct } });

        var pC = arc1.pointAt(cntA);
        var p1e = arc1.pointAt(arc1.endAngle);
        var p1s = arc1.pointAt(arc1.startAngle);
        var p2e = arc2.pointAt(arc2.endAngle);
        var p2s = arc2.pointAt(arc2.startAngle);

        if (innerArc == null) {
            path1.moveTo(c1.x, c1.y);
            path1.lineTo(c2.x, c2.y);
            path1.lineTo(p2e.x, p2e.y);
            path1.lineTo(p1e.x, p1e.y).close();
            path1.topology = { tname: "crvl", arc1, arc2, sa: arc1.startAngle, ea: arc1.endAngle };
            path2.moveTo(c1.x, c1.y);
            path2.lineTo(c2.x, c2.y);
            path2.lineTo(p2s.x, p2s.y);
            path2.lineTo(p1s.x, p1s.y).close();
            path2.topology = { tname: "crvr", arc1, arc2, sa: arc1.startAngle, ea: arc1.endAngle };
            path3.moveTo(p1e.x, p1e.y);
            path3.arc(arc1.endAngle, arc1.startAngle, arc1.radiusX, arc1.radiusY, true);
            path3.lineTo(p2s.x, p2s.y);
            path3.arc(arc2.startAngle, arc2.endAngle, arc2.radiusX, arc2.radiusY, false).close();
            path3.topology = { tname: "crvo", arc1, arc2, sa: arc1.startAngle, ea: arc1.endAngle };
            path4.topology = { tname: "crvi" };
        } else {
            innerArc.center = c1;
            var i1e = innerArc.pointAt(innerArc.endAngle);
            var i1s = innerArc.pointAt(innerArc.startAngle);
            innerArc.center = c2;
            var i2e = innerArc.pointAt(innerArc.endAngle);
            var i2s = innerArc.pointAt(innerArc.startAngle);
            path1.moveTo(i1e.x, i1e.y);
            path1.lineTo(p1e.x, p1e.y);
            path1.lineTo(p2e.x, p2e.y);
            path1.lineTo(i2e.x, i2e.y).close();
            path1.topology = { tname: "crvr", arc1, arc2, sa: arc1.startAngle, ea: arc1.endAngle };
            path2.moveTo(i1s.x, i1s.y);
            path2.lineTo(p1s.x, p1s.y);
            path2.lineTo(p2s.x, p2s.y);
            path2.lineTo(i2s.x, i2s.y).close();
            path2.topology = { tname: "crvl", arc1, arc2, sa: arc1.startAngle, ea: arc1.endAngle };
            path3.moveTo(i1e.x, i1e.y);
            path3.arc(innerArc.endAngle, innerArc.startAngle, innerArc.radiusX, innerArc.radiusY, true);
            path3.lineTo(i2s.x, i2s.y);
            path3.arc(innerArc.startAngle, innerArc.endAngle, innerArc.radiusX, innerArc.radiusY, false).close();
            path3.topology = { tname: "crvi", arc1, arc2, sa: arc1.startAngle, ea: arc1.endAngle };
            path4.moveTo(p1e.x, p1e.y);
            path4.arc(arc1.endAngle, arc1.startAngle, arc1.radiusX, arc1.radiusY, true);
            path4.lineTo(p2s.x, p2s.y);
            path4.arc(arc2.startAngle, arc2.endAngle, arc2.radiusX, arc2.radiusY, false).close();
            path4.topology = { tname: "crvo", arc1, arc2, sa: arc1.startAngle, ea: arc1.endAngle };
        }
        gp.append(path1);
        gp.append(path2);
        gp.append(path3);
        gp.append(path4);
        return gp;
    }
    function moveCenterPoint(center, e, dR) {
        dR = dR && dR > 0 ? dR : 0.1;
        var cntA = (e.startAngle + e.endAngle) / 2;
        var a = new geom.Arc(center, { 'startAngle': e.startAngle, 'endAngle': e.endAngle, 'radiusX': e.radiusX * dR, 'radiusY': e.radiusY * dR });
        var r = a.pointAt(cntA);
        return r;
    }
    function renderTextOnPie(arc, center, txtTorender, clipArea, bcolor) {
        var tcolor = invertColor(bcolor, true);
        var circleGeometry = new geom.Arc(center, arc);
        circleGeometry.radiusX = circleGeometry.radiusX * 7 / 8;
        circleGeometry.radiusY = circleGeometry.radiusY * 7 / 8;
        var bbox = circleGeometry.bbox();
        var group = new Group();
        var layout = new drawing.Layout(bbox, { spacing: 5, alignItems: "center" });
        var overlay = drawing.Path.fromRect(bbox, { fill: { color: "#fff", opacity: 0.00 }, stroke: { color: "none" }, cursor: "pointer" });

        var text = new drawing.Text(txtTorender, [0, 0], { font: "18px Rubik,Arial,sans-serif", fill: { color: tcolor } });

        // Align the text in the bounding box (center alignment)
        drawing.align([text], bbox, "center");
        drawing.vAlign([text], bbox, "top");

        // Retrieve the current position
        var currentPos = text.position();

        // Apply adjustments: reduce x by 12 and increase y by 10 just to move text from center
        var adjustedX = currentPos.x - 12;
        var adjustedY = currentPos.y + 10;
        text.position([adjustedX, adjustedY]);
        layout.append(text);
        group.append(layout);

        return group;
    }
    function padZero(str, len) {
        len = len || 2;
        var zeros = new Array(len).join('0');
        return (zeros + str).slice(-len);
    }
    function adjustSeriesForPie(chartEl, options, stgs) {
        if (!options || !options.series) return;
        options.xstgs = stgs;
        options.xseriesCurrent = stgs.xseriesCurrent > 0 ? stgs.xseriesCurrent : 0;
        if (options.series.length < options.xseriesCurrent) options.xseriesCurrent = 0;
        var xseries = options.series;
        options.series = xseries.length > 0 ? [xseries[options.xseriesCurrent]] : xseries;
        var pager = chartEl.closest(".chart-wrapper").find(".series-pager");
        if (pager.attr("data-initialized") == "1") return;
        pager.attr("data-initialized", "1");

        var ul = pager.find(".series-list");
        if (ul.length < 1) {
            ul = $("<ul></ul>");
            ul.appendTo(pager);
        }
        if (xseries.length > 1) {
            pager.find(".series-item-title").removeClass("d-none");
            xseries.forEach((vi, vii) => ul.append("<li class='series-item mr-1 p-1" + (vii === 0 ? " active" : "") + "' data-index='" + vii + "'>" + "" + (vi.name ? vi.name : " " + (vii + 1)) + "</li>"));
        }
        pager.off("mouseover").off("mouseout").off("click")
            .on("click", ".series-item-rotate", function () {
                let mbox = chartEl.data("kendoChart");
                if (mbox) mbox.options.enableRotationSate = !mbox.options.enableRotationSate;
            })
            .on("click", ".series-item", function () {
                if ($(this).hasClass("active")) return;
                pager.find(".series-item").removeClass("active");
                $(this).addClass("active");
                showPieOrDonutSerie(chartEl, Number.parseInt($(this).attr("data-index")));
            })
            .on("mouseover", ".series-item-rotate", function () {
                let mbox = chartEl.data("kendoChart");
                if (mbox) mbox.options.enableRotation = mbox.options.enableRotationSate;
            })
            .on("mouseout", ".series-item-rotate", function () {
                let mbox = chartEl.data("kendoChart");
                if (mbox) mbox.options.enableRotation = !mbox.options.enableRotationSate;
            });
        pager.removeClass("d-none");
    }
    function invertColor(ihex, bw) {
        var hex = ihex.indexOf('#') === 0 ? ihex.slice(1) : ihex;
        var r, g, b, a;
        if (hex.indexOf("rgb(") > -1 || hex.indexOf("rgba(") > -1) {
            hex = hex.replace("rgb(", "").replace("rgba(", "").replace(")", "");
            hex = hex.split(",").map(function (xi) {
                return parseInt(xi);
            });
            r = hex[0], g = hex[1], b = hex[2], a = hex[3];
        } else {
            // convert 3-digit hex to 6-digits.
            if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            if (hex.length !== 6) throw new Error('Invalid HEX color.');
            r = parseInt(hex.slice(0, 2), 16),
                g = parseInt(hex.slice(2, 4), 16),
                b = parseInt(hex.slice(4, 6), 16);
        }
        if (bw) {
            // http://stackoverflow.com/a/3943023/112731
            return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                ? '#000000'
                : '#FFFFFF';
        }
        // invert color components
        r = (255 - r).toString(16);
        g = (255 - g).toString(16);
        b = (255 - b).toString(16);
        var AA = A || A == 0 ? A.toString(16) : "";
        // pad each with zeros and return
        return "#" + padZero(r) + padZero(g) + padZero(b) + AA;
    }
    function shadeColor(ihex, percent) {
        if (typeof (ihex) === "function") ihex = ihex();
        var hex = ihex.indexOf('#') === 0 ? ihex.slice(1) : ihex;
        var R, G, B, A;
        if (hex.indexOf("rgb(") > -1 || hex.indexOf("rgba(") > -1) {
            hex = hex.replace("rgb(", "").replace("rgba(", "").replace(")", "");
            hex = hex.split(",").map(function (xi) {
                return parseInt(xi);
            });
            R = hex[0], G = hex[1], B = hex[2], A = hex[3];
        } else {
            // convert 3-digit hex to 6-digits.
            if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            if (hex.length !== 6) throw new Error('Invalid HEX color.');
            R = parseInt(hex.slice(0, 2), 16), G = parseInt(hex.slice(2, 4), 16), B = parseInt(hex.slice(4, 6), 16);
        }
        R = parseInt(R * (100 + percent) / 100);
        G = parseInt(G * (100 + percent) / 100);
        B = parseInt(B * (100 + percent) / 100);

        R = (R < 255) ? R : 255;
        G = (G < 255) ? G : 255;
        B = (B < 255) ? B : 255;

        var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
        var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
        var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));
        var AA = A || A == 0 ? A.toString(16) : "";
        return "#" + RR + GG + BB + AA;
    }
    function isOneOf(ixval, ...others) {
        let xval = (ixval || "").toLowerCase();
        let ix = others.find(function (x) {
            return x.toLowerCase() == xval;
        });
        return ix ? true : false;
    }
    function isLast(e) {
        let ltopology = null;
        e.series.data.forEach((x, i) => ltopology = ((x.value !== 0 && (e.series.pointVisibility || {})[i] !== false) ? x.topology : ltopology));
        var r = ltopology && ltopology.orderNo == e.dataItem.topology.orderNo;
        return r;
    };
    function filterOutInvisible(e, data) {
        if (!e.series) return data;
        var r = data.filter(function (x, i) {
            return x.value != null && x.value !== 0 && (e.series.pointVisibility || {})[i] !== false;
        });
        if (r.length != data.length) {
            return r;
        }
        return r;
    };
    function ensureCategoryFormatForWeek(sttgs) {
        if (!sttgs) return sttgs;
        if (!sttgs.legendformat || sttgs.legendformat.toLowerCase().indexOf('w') < 0) return sttgs;
        if (!sttgs.series || sttgs.series.length < 1) return sttgs;

        let categoriesFilledIn = false;
        sttgs.series.forEach(sx => {
            if (sx && sx.data && sx.data.length > 0) {
                sx.data.forEach((dx, di) => {
                    dx.category = formatCategoryWeekIncld(dx, sttgs.legendformat, sx);
                });
                if (!categoriesFilledIn) {
                    sttgs.categories = [];
                    sx.data.forEach(dx => sttgs.categories.push(dx.category));
                    categoriesFilledIn = true;
                }
            }
        });

        return sttgs;
    };
    function formatCategoryWeekIncld(xdata, formatStr, xserie) {
        if (formatStr.indexOf('y') > -1) formatStr = upperCaseYearFormat(formatStr);
        const stDate = moment(xdata.startdate, "YYYY-MM-DD");
        const edDate = moment(xdata.enddate, "YYYY-MM-DD");
        //const str = "[" + stDate.format("YYYY-MM-DD") + " ] - [" + edDate.format("YYYY-MM-DD") + "]";
        if (stDate.isValid() && edDate.isValid()) {
            const dmsec = Math.abs((Math.floor(stDate.diff(edDate, "milliseconds") / 2)));
            const mdDate = dmsec == 0 ? stDate : (stDate > edDate ? edDate : stDate).add(dmsec, "milliseconds");
            xdata.category = mdDate.format(formatStr);
            //console.log(str + " - [" + mdDate.format("YYYY-MM-DD") + "][" + xdata.category + "]      -" + formatStr);
        }
        return xdata.category;
    };
    function upperCaseYearFormat(s) {
        var r = "";
        while (s && s.length) {
            const st = s.indexOf('[');
            if (st < 0) {
                r = r + s.replaceAll('y', 'Y');
                s = "";
            }
            else
            {
                const ed = s.indexOf(']');
                if (ed < 0) {
                    r = r + s.replaceAll('y', 'Y');
                    s = "";
                } else {
                    r = r + s.substring(st, ed);
                    s = s.substring(ed);
                }
            }
        }
        return r;
    };
    return self;
}());
